import {Modal} from '@material-ui/core'
import React, {useEffect} from 'react'
import {ReservationConfigurationContext} from '../../context/ReservationConfiguration'
import {StepActionContext} from '../../context/StepAction'
import NextStepActionForm from './NextStepActionForm'

export default function NextStepActionModal({
  open,
  onClose,
  onSave,
  onSaved,
  group_id,
  object_ids,
  action,
  uid,
  setItemSelected,
  setItemUpdated,
  itemSelected,
  tabActive,
  isReturn = false,
}) {
  const {groupActionFields, getGroupActionFields} = React.useContext(
    ReservationConfigurationContext
  )
  const {stepActionData, setStepActionData, update} = React.useContext(StepActionContext)
  const fieldValueKey = `${group_id}_${action?.id}`
  useEffect(() => {
    if (action?.id && group_id) {
      getGroupActionFields({group_id: group_id, action_id: action.id, all_fields: true})
    }
    return () => {}
  }, [action, group_id, getGroupActionFields])

  useEffect(() => {
    if (groupActionFields.data[fieldValueKey]) {
      update('entity_id', group_id)
      update('entity_action_id', action.id)
      update('object_ids', object_ids)
      update('reservation_uid', uid)
      update('return', isReturn ? 'true' : false)
      let _actionFields = []
      if (!isReturn) {
        groupActionFields.data[fieldValueKey].map(af => {
          if (af.is_open_field) {
            _actionFields.push({
              ...af,
              value: '',
            })
          }
          return 0
        })
      } else
        groupActionFields.data[fieldValueKey].map(af => {
          if (!af.is_open_field) {
            _actionFields.push({
              ...af,
              value: '',
            })
          }
          return 0
        })
      update('action_fields', _actionFields)
    }
    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupActionFields, fieldValueKey, group_id, isReturn])

  return (
    <Modal
      style={{position: 'absolute'}}
      open={open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <NextStepActionForm
        action={action}
        tabActive={tabActive}
        onClose={onClose}
        setItemSelected={setItemSelected}
        setItemUpdated={setItemUpdated}
        itemSelected={itemSelected}
        onSaved={onSaved}
        isReturn={isReturn}
      />
    </Modal>
  )
}
